/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type UpdateHardwareItemMutationVariables = Types.Exact<{
  id: Types.Scalars["Float"];
  total_quantity?: Types.Maybe<Types.Scalars["Float"]>;
  available_quantity?: Types.Maybe<Types.Scalars["Float"]>;
}>;

export type UpdateHardwareItemMutation = {
  updateHardwareItem: Pick<
    Types.HardwareItem,
    "id" | "sku_code" | "total_quantity" | "available_quantity"
  >;
};

export const UpdateHardwareItemDocument = gql`
  mutation UpdateHardwareItem(
    $id: Float!
    $total_quantity: Float
    $available_quantity: Float
  ) {
    updateHardwareItem(
      id: $id
      total_quantity: $total_quantity
      available_quantity: $available_quantity
    ) {
      id
      sku_code
      total_quantity
      available_quantity
    }
  }
`;

/**
 * __useUpdateHardwareItemMutation__
 *
 * To run a mutation, you first call `useUpdateHardwareItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHardwareItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHardwareItemMutation, { data, loading, error }] = useUpdateHardwareItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      total_quantity: // value for 'total_quantity'
 *      available_quantity: // value for 'available_quantity'
 *   },
 * });
 */
export function useUpdateHardwareItemMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateHardwareItemMutation,
    UpdateHardwareItemMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdateHardwareItemMutation,
    UpdateHardwareItemMutationVariables
  >(UpdateHardwareItemDocument, baseOptions);
}
export type UpdateHardwareItemMutationHookResult = ReturnType<
  typeof useUpdateHardwareItemMutation
>;
export type UpdateHardwareItemMutationResult =
  ApolloReactCommon.MutationResult<UpdateHardwareItemMutation>;
export type UpdateHardwareItemMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateHardwareItemMutation,
    UpdateHardwareItemMutationVariables
  >;
